import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectInput({
  endAdornment,
  startAdornment,
  label,
  fullWidth,
  options = [],
  value,
  onChange,
  keys = null,
  style,
}) {
  return (
    <FormControl fullWidth={fullWidth} style={style}>
      <InputLabel
        id="demo-simple-select-label"
        sx={{
          px: 1,
          background: '#fff',
        }}
      >
        {label}
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label={label}
        onChange={onChange}
        endAdornment={endAdornment}
        startAdornment={startAdornment}
        style={{ borderRadius: 50 }}
      >
        {options.map((item, idx) => {
          return (
            <MenuItem key={idx} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
